import { store } from '@/store';
import { setUsers } from '@/store/slices/usersSlice';
import { setVehicles } from '@/store/slices/vehiclesSlice';
import { setBookings } from '@/store/slices/bookingsSlice';
import { setDrivers } from '@/store/slices/driversSlice';

// Initialize store with sample data for development
export const initializeStoreWithSampleData = () => {
  // Sample data is now loaded from API instead of static imports
  // This function can be used to fetch and populate initial data
  const state = store.getState();


  // Note: This function is now a no-op. Data should be fetched from API endpoints
  // when components mount rather than pre-populated with sample data.
};